<template>
  <ScModal
    :show="show"
    class="change-email-modal"
    @close="close"
  >
    <form
      v-if="show"
      @submit.prevent="onSubmit"
      novalidate
    >
      <div class="modal-header">
        <h5 class="modal-title">
          {{ $t(`account.changeEmailModal.changeEmail`) }}
        </h5>
        <button
          type="button"
          class="close"
          @click="close"
        >
          <span>&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div
          class="form-input"
          v-for="(input, index) in modalData"
          :key="'form-input-'+index"
        >
          <ScLabel>
            {{ $t(`account.changeEmailModal.labels.${input.key}`) }}
          </ScLabel>
          <ScInput
            :class="{invalid: errors.has(input.key)}"
            :ref="input.key"
            v-validate="input.validation"
            :name="input.key"
            :data-vv-name="input.key"
            v-model="input.value"
            :placeholder="$t(`account.changeEmailModal.placeholder.${input.key}`)"
          />
          <span
            v-if="errors.has(input.key)"
            class="error-message"
          >
            {{ errors.first(input.key) }}
          </span>
        </div>
      </div>
      <div class="modal-footer">
        <InvisibleRecaptcha
          @callback="onCaptcha"
          :validate="onValidate"
          class="btn btn-lg btn-mp-primary btn-block"
          type="submit"
          :site-key="siteKey"
        >
          {{ $t(`account.changeEmailModal.changeEmailButton`) }}
        </InvisibleRecaptcha>
      </div>
    </form>
  </ScModal>
</template>

<script>

import ScLabel from '@trendyol/sc-ui-kit/ScLabel';
import ScInput from '@trendyol/sc-ui-kit/ScInput';
import ScModal from '@trendyol/sc-ui-kit/ScModal';
import RecaptchaService from '@/services/RecaptchaService';
import InvisibleRecaptcha from '@/components/Shared/InvisibleRecaptcha';
export default {
  name: 'ChangeEmailModal',
  components: {
    ScInput,
    InvisibleRecaptcha,
    ScLabel,
    ScModal,
  },

  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    show: {
      type: Boolean,
      default: false,
    },
  },

  data () {
    return {
      siteKey: RecaptchaService.getInvisibleSiteKey(),
      isInitial: true,
      modalData: [
        {
          key: 'currentEmail',
          value: '',
          validation: {
            required: true,
            scEmail: true,
            is: this.data.currentEmail,
          },
        },
        {
          key: 'newEmail',
          value: '',
          validation: {
            required: true,
            scEmail: true,
          },
        },
        {
          key: 'emailConfirmation',
          value: '',
          validation: {
            required: true,
            confirmed: 'newEmail',
          },
        },
      ],
    };
  },
  watch: {
    show () {
      this.isInitial = true;
      this.modalData.map((val, index) => {
        this.$set(this.modalData[index], 'value', '');
      });
    },

    data: {
      handler (newData) {
        const currentEmailItem = this.modalData.find(item => item.key === 'currentEmail');

        currentEmailItem.validation.is = newData.currentEmail;
      },
      deep: true,
    },
  },
  methods: {
    close () {
      this.errors.clear();
      this.$emit('close');
    },
    onValidate () {
      return this.$validator.validate();
    },
    onCaptcha (captchaPayload) {
      let formattedData = this.modalData.reduce((obj, item) => {
        obj[item.key] = item.value;
        return obj;
      }, {});
      this.$emit('submit', captchaPayload, formattedData);
    },
    onSubmit () {
    },
  },

  created () {
    const dict = {
      custom: {
        currentEmail: {
          required: 'Zorunlu bir alandır',
          regex: 'Girilen E-Posta adresi geçersizdir',
          is: 'Mevcut E-Posta adresi eşlesmiyor',
        },
        newEmail: {
          required: 'Zorunlu bir alandır',
          regex: 'Girilen E-Posta adresi geçersizdir',
        },
        emailConfirmation: {
          required: 'Zorunlu bir alandır',
          regex: 'Girilen E-Posta adresi geçersizdir',
          confirmed: 'Girilen E-Posta adresi eşleşmiyor',
        },
      },
    };

    this.$validator.localize('tr', dict);
  },
};
</script>

<style lang="scss" scoped>
  .change-email-modal{
    & .modal-header{
      padding: 35px 30px 25px 30px;
      & .modal-title{
        font-size: 20px !important;
      }
    }
    & .modal-body{
      padding: 0 30px;

      .message-wrapper {
        margin-bottom: 30px;
        color: #273142;
        font-weight: 500;
        text-align: center;
        font-size: 20px;
        display: flex;
        align-items: center;
        flex-direction: column;

        img {
          margin-bottom: 30px;
        }
      }

      & .form-input {
        position: relative;
        &:not(:first-child) {
          margin-top: 20px;
        }
        &::v-deep input{
          height: 40px;
        }
        & .invalid{
          &::v-deep input{
            border-color: #dc3545;
          }
          &::v-deep .eye-icon:before{
            color: #dc3545;
          }
        }
      }
      .error-message {
        position: absolute;
        color: #dc3545;
      }
    }

    & .modal-footer{
      padding: 30px;
      border-top: none;
      & .form-button {
        width: 100%;
        height: 40px;
      }
    }
  }
</style>
